@if (user$ | async; as user) {
<div class="udex-grid udex-mx-auto udex-mb-40 heading__bold--xxxxs text-center text-black">
  {{ user?.email }}
</div>
}
